export const SultanMini = (color) => {
  return `
        <svg xmlns="http://www.w3.org/2000/svg" width="400" height="181" viewBox="0 0 400 181" fill="none">
      <rect width="400" height="45.3875" fill="${color}"/>
      <g filter="url(#filter0_ii_74_1594)">
      <rect x="9.48315" y="9.06049" width="118.539" height="27.8286" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter1_ii_74_1594)">
      <rect x="140.666" y="9.06049" width="118.539" height="27.8286" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter2_ii_74_1594)">
      <rect x="271.058" y="9.06049" width="118.539" height="27.8286" fill="#9B8E56"/>
      </g>
      <line y1="44.3875" x2="400" y2="44.3875" stroke="white" stroke-width="2"/>
      <rect width="400" height="45.3875" fill="${color}"/>
      <line y1="44.8875" x2="400" y2="44.8875" stroke="#5D5D5D" stroke-opacity="0.66"/>
      <g filter="url(#filter3_ii_74_1594)">
      <rect x="8" y="9" width="79.7829" height="27.83" fill="#9B8E56"/>
      </g>
      <line x1="8" y1="12.6015" x2="88" y2="12.6015" stroke="white" stroke-opacity="0.4"/>
      <line x1="8" y1="32.904" x2="88" y2="32.904" stroke="white" stroke-opacity="0.4"/>
      <line x1="8" y1="17.2157" x2="88" y2="17.2157" stroke="white" stroke-opacity="0.4"/>
      <line x1="8" y1="27.3669" x2="88" y2="27.3669" stroke="white" stroke-opacity="0.4"/>
      <line x1="8" y1="22.7527" x2="88" y2="22.7527" stroke="white" stroke-opacity="0.4"/>
      <g filter="url(#filter4_ii_74_1594)">
      <rect x="310" y="9" width="79.7829" height="27.83" fill="#9B8E56"/>
      </g>
      <line x1="310" y1="12.6015" x2="390" y2="12.6015" stroke="white" stroke-opacity="0.4"/>
      <line x1="310" y1="32.904" x2="390" y2="32.904" stroke="white" stroke-opacity="0.4"/>
      <line x1="310" y1="17.2157" x2="390" y2="17.2157" stroke="white" stroke-opacity="0.4"/>
      <line x1="310" y1="27.3669" x2="390" y2="27.3669" stroke="white" stroke-opacity="0.4"/>
      <line x1="310" y1="22.7527" x2="390" y2="22.7527" stroke="white" stroke-opacity="0.4"/>
      <g filter="url(#filter5_ii_74_1594)">
      <rect x="96" y="9" width="205.441" height="27.83" fill="#9B8E56"/>
      </g>
      <line x1="96" y1="12.6015" x2="302" y2="12.6015" stroke="white" stroke-opacity="0.4"/>
      <line x1="96" y1="32.904" x2="302" y2="32.904" stroke="white" stroke-opacity="0.4"/>
      <line x1="96" y1="17.2157" x2="302" y2="17.2157" stroke="white" stroke-opacity="0.4"/>
      <line x1="96" y1="27.3669" x2="302" y2="27.3669" stroke="white" stroke-opacity="0.4"/>
      <line x1="96" y1="22.7527" x2="302" y2="22.7527" stroke="white" stroke-opacity="0.4"/>
      <rect y="45" width="400" height="45.3875" fill="${color}"/>
      <g filter="url(#filter6_ii_74_1594)">
      <rect x="9.48315" y="54.0605" width="118.539" height="27.8286" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter7_ii_74_1594)">
      <rect x="140.666" y="54.0605" width="118.539" height="27.8286" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter8_ii_74_1594)">
      <rect x="271.058" y="54.0605" width="118.539" height="27.8286" fill="#9B8E56"/>
      </g>
      <line y1="89.3875" x2="400" y2="89.3875" stroke="white" stroke-width="2"/>
      <rect y="45" width="400" height="45.3875" fill="${color}"/>
      <line y1="89.8875" x2="400" y2="89.8875" stroke="#5D5D5D" stroke-opacity="0.66"/>
      <g filter="url(#filter9_ii_74_1594)">
      <rect x="8" y="54" width="79.7829" height="27.83" fill="#9B8E56"/>
      </g>
      <line x1="8" y1="57.6015" x2="88" y2="57.6015" stroke="white" stroke-opacity="0.4"/>
      <line x1="8" y1="77.904" x2="88" y2="77.904" stroke="white" stroke-opacity="0.4"/>
      <line x1="8" y1="62.2157" x2="88" y2="62.2157" stroke="white" stroke-opacity="0.4"/>
      <line x1="8" y1="72.3669" x2="88" y2="72.3669" stroke="white" stroke-opacity="0.4"/>
      <line x1="8" y1="67.7527" x2="88" y2="67.7527" stroke="white" stroke-opacity="0.4"/>
      <g filter="url(#filter10_ii_74_1594)">
      <rect x="310" y="54" width="79.7829" height="27.83" fill="#9B8E56"/>
      </g>
      <line x1="310" y1="57.6015" x2="390" y2="57.6015" stroke="white" stroke-opacity="0.4"/>
      <line x1="310" y1="77.904" x2="390" y2="77.904" stroke="white" stroke-opacity="0.4"/>
      <line x1="310" y1="62.2157" x2="390" y2="62.2157" stroke="white" stroke-opacity="0.4"/>
      <line x1="310" y1="72.3669" x2="390" y2="72.3669" stroke="white" stroke-opacity="0.4"/>
      <line x1="310" y1="67.7527" x2="390" y2="67.7527" stroke="white" stroke-opacity="0.4"/>
      <g filter="url(#filter11_ii_74_1594)">
      <rect x="96" y="54" width="205.441" height="27.83" fill="#9B8E56"/>
      </g>
      <line x1="96" y1="57.6015" x2="302" y2="57.6015" stroke="white" stroke-opacity="0.4"/>
      <line x1="96" y1="77.904" x2="302" y2="77.904" stroke="white" stroke-opacity="0.4"/>
      <line x1="96" y1="62.2157" x2="302" y2="62.2157" stroke="white" stroke-opacity="0.4"/>
      <line x1="96" y1="72.3669" x2="302" y2="72.3669" stroke="white" stroke-opacity="0.4"/>
      <line x1="96" y1="67.7527" x2="302" y2="67.7527" stroke="white" stroke-opacity="0.4"/>
      <rect y="90" width="400" height="45.3875" fill="${color}"/>
      <g filter="url(#filter12_ii_74_1594)">
      <rect x="9.48315" y="99.0605" width="118.539" height="27.8286" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter13_ii_74_1594)">
      <rect x="140.666" y="99.0605" width="118.539" height="27.8286" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter14_ii_74_1594)">
      <rect x="271.058" y="99.0605" width="118.539" height="27.8286" fill="#9B8E56"/>
      </g>
      <line y1="134.387" x2="400" y2="134.387" stroke="white" stroke-width="2"/>
      <rect y="90" width="400" height="45.3875" fill="${color}"/>
      <line y1="134.887" x2="400" y2="134.887" stroke="#5D5D5D" stroke-opacity="0.66"/>
      <g filter="url(#filter15_ii_74_1594)">
      <rect x="8" y="99" width="79.7829" height="27.83" fill="#9B8E56"/>
      </g>
      <line x1="8" y1="102.602" x2="88" y2="102.602" stroke="white" stroke-opacity="0.4"/>
      <line x1="8" y1="122.904" x2="88" y2="122.904" stroke="white" stroke-opacity="0.4"/>
      <line x1="8" y1="107.216" x2="88" y2="107.216" stroke="white" stroke-opacity="0.4"/>
      <line x1="8" y1="117.367" x2="88" y2="117.367" stroke="white" stroke-opacity="0.4"/>
      <line x1="8" y1="112.753" x2="88" y2="112.753" stroke="white" stroke-opacity="0.4"/>
      <g filter="url(#filter16_ii_74_1594)">
      <rect x="310" y="99" width="79.7829" height="27.83" fill="#9B8E56"/>
      </g>
      <line x1="310" y1="102.602" x2="390" y2="102.602" stroke="white" stroke-opacity="0.4"/>
      <line x1="310" y1="122.904" x2="390" y2="122.904" stroke="white" stroke-opacity="0.4"/>
      <line x1="310" y1="107.216" x2="390" y2="107.216" stroke="white" stroke-opacity="0.4"/>
      <line x1="310" y1="117.367" x2="390" y2="117.367" stroke="white" stroke-opacity="0.4"/>
      <line x1="310" y1="112.753" x2="390" y2="112.753" stroke="white" stroke-opacity="0.4"/>
      <g filter="url(#filter17_ii_74_1594)">
      <rect x="96" y="99" width="205.441" height="27.83" fill="#9B8E56"/>
      </g>
      <line x1="96" y1="102.602" x2="302" y2="102.602" stroke="white" stroke-opacity="0.4"/>
      <line x1="96" y1="122.904" x2="302" y2="122.904" stroke="white" stroke-opacity="0.4"/>
      <line x1="96" y1="107.216" x2="302" y2="107.216" stroke="white" stroke-opacity="0.4"/>
      <line x1="96" y1="117.367" x2="302" y2="117.367" stroke="white" stroke-opacity="0.4"/>
      <line x1="96" y1="112.753" x2="302" y2="112.753" stroke="white" stroke-opacity="0.4"/>
      <rect y="135" width="400" height="45.3875" fill="${color}"/>
      <g filter="url(#filter18_ii_74_1594)">
      <rect x="9.48315" y="144.06" width="118.539" height="27.8286" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter19_ii_74_1594)">
      <rect x="140.666" y="144.06" width="118.539" height="27.8286" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter20_ii_74_1594)">
      <rect x="271.058" y="144.06" width="118.539" height="27.8286" fill="#9B8E56"/>
      </g>
      <line y1="179.387" x2="400" y2="179.387" stroke="white" stroke-width="2"/>
      <rect y="135" width="400" height="45.3875" fill="${color}"/>
      <line y1="179.887" x2="400" y2="179.887" stroke="#5D5D5D" stroke-opacity="0.66"/>
      <g filter="url(#filter21_ii_74_1594)">
      <rect x="8" y="144" width="79.7829" height="27.83" fill="#9B8E56"/>
      </g>
      <line x1="8" y1="147.602" x2="88" y2="147.602" stroke="white" stroke-opacity="0.4"/>
      <line x1="8" y1="167.904" x2="88" y2="167.904" stroke="white" stroke-opacity="0.4"/>
      <line x1="8" y1="152.216" x2="88" y2="152.216" stroke="white" stroke-opacity="0.4"/>
      <line x1="8" y1="162.367" x2="88" y2="162.367" stroke="white" stroke-opacity="0.4"/>
      <line x1="8" y1="157.753" x2="88" y2="157.753" stroke="white" stroke-opacity="0.4"/>
      <g filter="url(#filter22_ii_74_1594)">
      <rect x="310" y="144" width="79.7829" height="27.83" fill="#9B8E56"/>
      </g>
      <line x1="310" y1="147.602" x2="390" y2="147.602" stroke="white" stroke-opacity="0.4"/>
      <line x1="310" y1="167.904" x2="390" y2="167.904" stroke="white" stroke-opacity="0.4"/>
      <line x1="310" y1="152.216" x2="390" y2="152.216" stroke="white" stroke-opacity="0.4"/>
      <line x1="310" y1="162.367" x2="390" y2="162.367" stroke="white" stroke-opacity="0.4"/>
      <line x1="310" y1="157.753" x2="390" y2="157.753" stroke="white" stroke-opacity="0.4"/>
      <g filter="url(#filter23_ii_74_1594)">
      <rect x="96" y="144" width="205.441" height="27.83" fill="#9B8E56"/>
      </g>
      <line x1="96" y1="147.602" x2="302" y2="147.602" stroke="white" stroke-opacity="0.4"/>
      <line x1="96" y1="167.904" x2="302" y2="167.904" stroke="white" stroke-opacity="0.4"/>
      <line x1="96" y1="152.216" x2="302" y2="152.216" stroke="white" stroke-opacity="0.4"/>
      <line x1="96" y1="162.367" x2="302" y2="162.367" stroke="white" stroke-opacity="0.4"/>
      <line x1="96" y1="157.753" x2="302" y2="157.753" stroke="white" stroke-opacity="0.4"/>
      <defs>
      <filter id="filter0_ii_74_1594" x="7.48315" y="7.06049" width="122.539" height="31.8286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter1_ii_74_1594" x="138.666" y="7.06049" width="122.539" height="31.8286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter2_ii_74_1594" x="269.058" y="7.06049" width="122.539" height="31.8286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter3_ii_74_1594" x="6" y="7" width="83.783" height="31.83" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter4_ii_74_1594" x="308" y="7" width="83.783" height="31.83" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter5_ii_74_1594" x="94" y="7" width="209.441" height="31.83" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter6_ii_74_1594" x="7.48315" y="52.0605" width="122.539" height="31.8286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter7_ii_74_1594" x="138.666" y="52.0605" width="122.539" height="31.8286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter8_ii_74_1594" x="269.058" y="52.0605" width="122.539" height="31.8286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter9_ii_74_1594" x="6" y="52" width="83.783" height="31.83" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter10_ii_74_1594" x="308" y="52" width="83.783" height="31.83" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter11_ii_74_1594" x="94" y="52" width="209.441" height="31.83" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter12_ii_74_1594" x="7.48315" y="97.0605" width="122.539" height="31.8286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter13_ii_74_1594" x="138.666" y="97.0605" width="122.539" height="31.8286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter14_ii_74_1594" x="269.058" y="97.0605" width="122.539" height="31.8286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter15_ii_74_1594" x="6" y="97" width="83.783" height="31.83" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter16_ii_74_1594" x="308" y="97" width="83.783" height="31.83" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter17_ii_74_1594" x="94" y="97" width="209.441" height="31.83" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter18_ii_74_1594" x="7.48315" y="142.06" width="122.539" height="31.8286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter19_ii_74_1594" x="138.666" y="142.06" width="122.539" height="31.8286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter20_ii_74_1594" x="269.058" y="142.06" width="122.539" height="31.8286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter21_ii_74_1594" x="6" y="142" width="83.783" height="31.83" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter22_ii_74_1594" x="308" y="142" width="83.783" height="31.83" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      <filter id="filter23_ii_74_1594" x="94" y="142" width="209.441" height="31.83" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_74_1594"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_74_1594"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_74_1594"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_74_1594" result="effect2_innerShadow_74_1594"/>
      </filter>
      </defs>
      </svg>
        `;
};
